// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6045":"f27b4f6f4773a56a","9885":"2430b7d2b0ec3667"}[chunkId] + ".js";
};